import { type PatsnapCopilotUsage, CopilotPlan } from '@analytics/patsnap-copilot/src/patsnap-copilot-service.interface';
import type { PatsnapCopilotUsageService } from '@analytics/patsnap-copilot/src/patsnap-copilot-usage-service';
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { ApiCopilotInit } from '../apis/core-basic-api-service.interface';

@injectable()
export class PatsnapCopilotUsageServiceImpl implements PatsnapCopilotUsageService {
    constructor(
        @inject(ApiCopilotInit)
        private readonly _apiCopilotInit: ApiCopilotInit,
    ) {

    }

    async getUsage(): Promise<PatsnapCopilotUsage> {
        // headers: {
        //     'X-API-Version': '1.0',
        // },
        // url: `${process.env.VUE_APP_CORE_BASIC_SERVICE_URI}/core-copilot-api/analytics/copilot/init`,
        try {
            const res = await this._apiCopilotInit.copilotInit({});

            return {
                enabled: res.copilot_flag,
                currentAmount: res.copilot_usage,
                maxAmount: res.copilot_limitation,
                upgradeInvite: false,
                plan: res.copilot_qaflag ? CopilotPlan.B : CopilotPlan.A,
                webAccess: res.copilot_google_flag,
            };
        } catch (e) {
            return {
                enabled: false,
                currentAmount: 0,
                maxAmount: 0,
                upgradeInvite: false,
                plan: CopilotPlan.A,
                webAccess: false,
            };
        }
    }
}
